import { render, staticRenderFns } from "./managementMenu.vue?vue&type=template&id=05d36966&scoped=true&"
import script from "./managementMenu.vue?vue&type=script&lang=js&"
export * from "./managementMenu.vue?vue&type=script&lang=js&"
import style0 from "./managementMenu.vue?vue&type=style&index=0&id=05d36966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d36966",
  null
  
)

export default component.exports